export default () => {
  let allDashboards = ["seo", "ppc", "search", "social", "display", "video"];
  let allSeoDashboards = ["seo"];
  let allPpcDashboards = ["ppc", "search", "social", "display", "video"];
  let allMetrics = {};

  let metricData = require("data/metricData.json");

  let sectionData = require("data/sectionData.json");

  let metricsByDashboard = {
    seo: {
      sections: {
        goalsAndProjections: sectionData.goalsAndProjections,
        primaryKpiCharts: sectionData.primaryKpiCharts,
        primaryKpiTables: sectionData.primaryKpiTables,
        allKpisVsPreviousYear: sectionData.allKpisVsPreviousYear,
        landingPageBreakdown: sectionData.landingPageBreakdown,
        backlinks: sectionData.backlinks,
        keywordGroups: sectionData.keywordGroups,
        keywordSummary: sectionData.keywordSummary,
        keywordRankings: sectionData.keywordRankings,
      },
      metrics: {
        goalsAndProjections: {
          traffic: metricData.traffic,
          conversions: metricData.conversions,
          revenue: metricData.revenue,
          cvr: metricData.cvr,
          aov: metricData.aov,
          gscClicks: metricData.gscClicks,
          gscImpressions: metricData.gscImpressions,
          searchVisibility: metricData.searchVisibility,
          topThreeKeywords: metricData.topThreeKeywords,
          topThreeKeywordsPercentage: metricData.topThreeKeywordsPercentage,
          topTenKeywords: metricData.topTenKeywords,
          topTenKeywordsPercentage: metricData.topTenKeywordsPercentage,
          topTwentyKeywords: metricData.topTwentyKeywords,
          topTwentyKeywordsPercentage: metricData.topTwentyKeywordsPercentage,
        },
        primaryKpiCharts: {
          traffic: metricData.traffic,
          conversions: metricData.conversions,
          revenue: metricData.revenue,
          cvr: metricData.cvr,
          aov: metricData.aov,
          gscClicks: metricData.gscClicks,
          gscImpressions: metricData.gscImpressions,
          searchVisibility: metricData.searchVisibility,
          topThreeKeywords: metricData.topThreeKeywords,
          topThreeKeywordsPercentage: metricData.topThreeKeywordsPercentage,
          topTenKeywords: metricData.topTenKeywords,
          topTenKeywordsPercentage: metricData.topTenKeywordsPercentage,
          topTwentyKeywords: metricData.topTwentyKeywords,
          topTwentyKeywordsPercentage: metricData.topTwentyKeywordsPercentage,
        },
        primaryKpiTables: {
          traffic: metricData.traffic,
          conversions: metricData.conversions,
          revenue: metricData.revenue,
          cvr: metricData.cvr,
          aov: metricData.aov,
          gscClicks: metricData.gscClicks,
          gscImpressions: metricData.gscImpressions,
          searchVisibility: metricData.searchVisibility,
          topThreeKeywords: metricData.topThreeKeywords,
          topThreeKeywordsPercentage: metricData.topThreeKeywordsPercentage,
          topTenKeywords: metricData.topTenKeywords,
          topTenKeywordsPercentage: metricData.topTenKeywordsPercentage,
          topTwentyKeywords: metricData.topTwentyKeywords,
          topTwentyKeywordsPercentage: metricData.topTwentyKeywordsPercentage,
        },
        allKpisVsPreviousYear: {
          traffic: metricData.traffic,
          bounceRate: metricData.bounceRate,
          gscClicks: metricData.gscClicks,
          gscImpressions: metricData.gscImpressions,
          engagedSessions: metricData.engagedSessions,
          conversions: metricData.conversions,
          revenue: metricData.revenue,
          cvr: metricData.cvr,
          aov: metricData.aov,
          searchVisibility: metricData.searchVisibility,
          averagePosition: metricData.averagePosition,
          topThreeKeywords: metricData.topThreeKeywords,
          topThreeKeywordsPercentage: metricData.topThreeKeywordsPercentage,
          topTenKeywords: metricData.topTenKeywords,
          topTenKeywordsPercentage: metricData.topTenKeywordsPercentage,
          topTwentyKeywords: metricData.topTwentyKeywords,
          topTwentyKeywordsPercentage: metricData.topTwentyKeywordsPercentage,
        },
        landingPageBreakdown: {
          traffic: metricData.traffic,
          bounceRate: metricData.bounceRate,
          conversions: metricData.conversions,
          revenue: metricData.revenue,
          cvr: metricData.cvr,
          aov: metricData.aov,
          searchVisibility: metricData.searchVisibility,
          averagePosition: metricData.averagePosition,
          topThreeKeywords: metricData.topThreeKeywords,
          topThreeKeywordsPercentage: metricData.topThreeKeywordsPercentage,
          topTenKeywords: metricData.topTenKeywords,
          topTenKeywordsPercentage: metricData.topTenKeywordsPercentage,
          topTwentyKeywords: metricData.topTwentyKeywords,
          topTwentyKeywordsPercentage: metricData.topTwentyKeywordsPercentage,
        },
        backlinks: {
          totalBacklinks: metricData.totalBacklinks,
          referringIps: metricData.referringIps,
          referringDomains: metricData.referringDomains,
          authorityScore: metricData.authorityScore,
        },
        keywordGroups: {
          traffic: metricData.traffic,
        },
        keywordSummary: {
          keywordsImproved: metricData.keywordsImproved,
          keywordsDeclined: metricData.keywordsDeclined,
          topThreeKeywords: metricData.topThreeKeywords,
          topThreeKeywordsPercentage: metricData.topThreeKeywordsPercentage,
          topTenKeywords: metricData.topTenKeywords,
          topTenKeywordsPercentage: metricData.topTenKeywordsPercentage,
          topTwentyKeywords: metricData.topTwentyKeywords,
          topTwentyKeywordsPercentage: metricData.topTwentyKeywordsPercentage,
        },
        keywordRankings: {
          keywordName: metricData.keywordName,
          keywordSerpFeatures: metricData.keywordSerpFeatures,
          keywordPreviousPosition: metricData.keywordPreviousPosition,
          keywordCurrentPosition: metricData.keywordCurrentPosition,
          keywordDifference: metricData.keywordDifference,
          keywordCostPerConversion: metricData.keywordCostPerConversion,
          keywordSearchVolume: metricData.keywordSearchVolume,
          keywordLabel: metricData.keywordLabel,
          keywordDifficulty: metricData.keywordDifficulty,
          keywordUrl: metricData.keywordUrl,
        },
      },
      defaults: {
        ecommerce: {
          goalsAndProjections: {},
          primaryKpiCharts: {
            traffic: metricData.traffic,
            revenue: metricData.revenue,
          },
          primaryKpiTables: {
            traffic: metricData.traffic,
            revenue: metricData.revenue,
            cvr: metricData.cvr,
            aov: metricData.aov,
          },
          allKpisVsPreviousYear: {
            traffic: metricData.traffic,
            bounceRate: metricData.bounceRate,
            conversions: metricData.conversions,
            revenue: metricData.revenue,
            cvr: metricData.cvr,
            aov: metricData.aov,
            searchVisibility: metricData.searchVisibility,
          },
          landingPageBreakdown: {
            traffic: metricData.traffic,
          },
          backlinks: {
            totalBacklinks: metricData.totalBacklinks,
            referringIps: metricData.referringIps,
            referringDomains: metricData.referringDomains,
            authorityScore: metricData.authorityScore,
          },
          keywordGroups: {
            traffic: metricData.traffic,
          },
          keywordSummary: {
            keywordsImproved: metricData.keywordsImproved,
            keywordsDeclined: metricData.keywordsDeclined,
            topThreeKeywords: metricData.topThreeKeywords,
            topThreeKeywordsPercentage: metricData.topThreeKeywordsPercentage,
            topTenKeywords: metricData.topTenKeywords,
            topTenKeywordsPercentage: metricData.topTenKeywordsPercentage,
            topTwentyKeywords: metricData.topTwentyKeywords,
            topTwentyKeywordsPercentage: metricData.topTwentyKeywordsPercentage,
          },
          keywordRankings: {
            keywordName: metricData.keywordName,
            keywordPreviousPosition: metricData.keywordPreviousPosition,
            keywordCurrentPosition: metricData.keywordCurrentPosition,
            keywordDifference: metricData.keywordDifference,
            keywordDifficulty: metricData.keywordDifficulty,
            keywordSearchVolume: metricData.keywordSearchVolume,
            keywordUrl: metricData.keywordUrl,
          },
        },
        leadgen: {
          goalsAndProjections: {},
          primaryKpiCharts: {
            traffic: metricData.traffic,
            conversions: metricData.conversions,
          },
          primaryKpiTables: {
            traffic: metricData.traffic,
            conversions: metricData.conversions,
            cvr: metricData.cvr,
          },
          allKpisVsPreviousYear: {
            traffic: metricData.traffic,
            gscImpressions: metricData.gscImpressions,
            conversions: metricData.conversions,
            cvr: metricData.cvr,
            searchVisibility: metricData.searchVisibility,
          },
          landingPageBreakdown: {
            traffic: metricData.traffic,
          },
          backlinks: {
            totalBacklinks: metricData.totalBacklinks,
            referringIps: metricData.referringIps,
            referringDomains: metricData.referringDomains,
            authorityScore: metricData.authorityScore,
          },
          keywordGroups: {
            traffic: metricData.traffic,
          },
          keywordSummary: {
            keywordsImproved: metricData.keywordsImproved,
            keywordsDeclined: metricData.keywordsDeclined,
            topThreeKeywords: metricData.topThreeKeywords,
            topThreeKeywordsPercentage: metricData.topThreeKeywordsPercentage,
            topTenKeywords: metricData.topTenKeywords,
            topTenKeywordsPercentage: metricData.topTenKeywordsPercentage,
            topTwentyKeywords: metricData.topTwentyKeywords,
            topTwentyKeywordsPercentage: metricData.topTwentyKeywordsPercentage,
          },
          keywordRankings: {
            keywordName: metricData.keywordName,
            keywordPreviousPosition: metricData.keywordPreviousPosition,
            keywordCurrentPosition: metricData.keywordCurrentPosition,
            keywordDifficulty: metricData.keywordDifficulty,
            keywordSearchVolume: metricData.keywordSearchVolume,
            keywordUrl: metricData.keywordUrl,
          },
        },
        mandatory: {
          keywordRankings: {
            keywordName: metricData.keywordName,
          },
        },
      },
    },
    ppc: {
      sections: {
        goalsAndProjections: sectionData.goalsAndProjections,
        primaryKpiCharts: sectionData.primaryKpiCharts,
        primaryKpiTables: sectionData.primaryKpiTables,
        allKpisVsPreviousYear: sectionData.allKpisVsPreviousYear,
        performanceByChannel: sectionData.performanceByChannel,
        campaignGroups: sectionData.campaignGroups,
        spendAllocation: sectionData.spendAllocation,
      },
      metrics: {
        goalsAndProjections: {
          shopifyRevenue: metricData.shopifyRevenue,
          shopifyRoas: metricData.shopifyRoas,
          shopifySubtotalRevenue: metricData.shopifySubtotalRevenue,
          shopifySubtotalRoas: metricData.shopifySubtotalRoas,
          spend: metricData.spend,
          impressions: metricData.impressions,
          viewableImpressions: metricData.viewableImpressions,
          views: metricData.views,
          cpv: metricData.cpv,
          viewRate: metricData.viewRate,
          viewCtr: metricData.viewCtr,
          viewableCtr: metricData.viewableCtr,
          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          totalAov: metricData.totalAov,
        },
        primaryKpiCharts: {
          shopifyRevenue: metricData.shopifyRevenue,
          shopifyRoas: metricData.shopifyRoas,
          shopifySubtotalRevenue: metricData.shopifySubtotalRevenue,
          shopifySubtotalRoas: metricData.shopifySubtotalRoas,
          spend: metricData.spend,
          impressions: metricData.impressions,
          viewableImpressions: metricData.viewableImpressions,
          views: metricData.views,
          cpv: metricData.cpv,
          viewRate: metricData.viewRate,
          viewCtr: metricData.viewCtr,
          viewableCtr: metricData.viewableCtr,
          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          totalAov: metricData.totalAov,
        },
        primaryKpiTables: {
          shopifyRevenue: metricData.shopifyRevenue,
          shopifyRoas: metricData.shopifyRoas,
          shopifySubtotalRevenue: metricData.shopifySubtotalRevenue,
          shopifySubtotalRoas: metricData.shopifySubtotalRoas,
          spend: metricData.spend,
          impressions: metricData.impressions,
          viewableImpressions: metricData.viewableImpressions,
          views: metricData.views,
          cpv: metricData.cpv,
          viewRate: metricData.viewRate,
          viewCtr: metricData.viewCtr,
          viewableCtr: metricData.viewableCtr,
          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          totalAov: metricData.totalAov,
        },
        allKpisVsPreviousYear: {
          shopifyRevenue: metricData.shopifyRevenue,
          shopifyRoas: metricData.shopifyRoas,
          shopifySubtotalRevenue: metricData.shopifySubtotalRevenue,
          shopifySubtotalRoas: metricData.shopifySubtotalRoas,
          spend: metricData.spend,
          impressions: metricData.impressions,
          viewableImpressions: metricData.viewableImpressions,
          views: metricData.views,
          cpv: metricData.cpv,
          viewRate: metricData.viewRate,
          viewCtr: metricData.viewCtr,
          viewableCtr: metricData.viewableCtr,
          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          totalAov: metricData.totalAov,
        },
        performanceByChannel: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          viewableImpressions: metricData.viewableImpressions,
          views: metricData.views,
          cpv: metricData.cpv,
          viewRate: metricData.viewRate,
          viewCtr: metricData.viewCtr,
          viewableCtr: metricData.viewableCtr,
          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          totalAov: metricData.totalAov,
        },
        spendAllocation: {
          spend: metricData.spend,
          clickConversions: metricData.clickConversions,
          totalConversions: metricData.totalConversions,
          clickRevenue: metricData.clickRevenue,
          totalRevenue: metricData.totalRevenue,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
        },
      },
      defaults: {
        ecommerce: {
          goalsAndProjections: {},
          primaryKpiCharts: {
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
          },
          primaryKpiTables: {
            spend: metricData.spend,
            clicks: metricData.clicks,
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
          },
          allKpisVsPreviousYear: {
            spend: metricData.spend,
            impressions: metricData.impressions,
            clicks: metricData.clicks,
            cpc: metricData.cpc,
            ctr: metricData.ctr,
            phoneCalls: metricData.phoneCalls,
            totalConversions: metricData.totalConversions,
            cvr: metricData.cvr,
            totalCpa: metricData.totalCpa,
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
            totalAov: metricData.totalAov,
          },
          spendAllocation: {
            spend: metricData.spend,
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
          },
        },
        leadgen: {
          goalsAndProjections: {},
          primaryKpiCharts: {
            totalConversions: metricData.totalConversions,
            totalCpa: metricData.totalCpa,
          },
          primaryKpiTables: {
            spend: metricData.spend,
            clicks: metricData.clicks,
            totalConversions: metricData.totalConversions,
            totalCpa: metricData.totalCpa,
          },
          allKpisVsPreviousYear: {
            spend: metricData.spend,
            impressions: metricData.impressions,
            clicks: metricData.clicks,
            cpc: metricData.cpc,
            ctr: metricData.ctr,
            phoneCalls: metricData.phoneCalls,
            totalConversions: metricData.totalConversions,
            cvr: metricData.cvr,
            totalCpa: metricData.totalCpa,
          },
          spendAllocation: {
            spend: metricData.spend,
            totalConversions: metricData.totalConversions,
            totalCpa: metricData.totalCpa,
          },
        },
      },
    },
    search: {
      sections: {
        goalsAndProjections: sectionData.goalsAndProjections,
        primaryKpiCharts: sectionData.primaryKpiCharts,
        primaryKpiTables: sectionData.primaryKpiTables,
        allKpisVsPreviousYear: sectionData.allKpisVsPreviousYear,
        campaignGroups: sectionData.campaignGroups,
        spendAllocation: sectionData.spendAllocation,
      },
      metrics: {
        goalsAndProjections: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          impressionsTopRate: metricData.impressionsTopRate,
          impressionsAbsTopRate: metricData.impressionsAbsTopRate,
          searchImpressionsShare: metricData.searchImpressionsShare,
          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          clickRevenue: metricData.clickRevenue,
          clickRoas: metricData.clickRoas,
          clickAov: metricData.clickAov,
        },
        primaryKpiCharts: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          impressionsTopRate: metricData.impressionsTopRate,
          impressionsAbsTopRate: metricData.impressionsAbsTopRate,
          searchImpressionsShare: metricData.searchImpressionsShare,
          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          clickRevenue: metricData.clickRevenue,
          clickRoas: metricData.clickRoas,
          clickAov: metricData.clickAov,
        },
        primaryKpiTables: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          impressionsTopRate: metricData.impressionsTopRate,
          impressionsAbsTopRate: metricData.impressionsAbsTopRate,
          searchImpressionsShare: metricData.searchImpressionsShare,
          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          clickRevenue: metricData.clickRevenue,
          clickRoas: metricData.clickRoas,
          clickAov: metricData.clickAov,
        },
        allKpisVsPreviousYear: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          impressionsTopRate: metricData.impressionsTopRate,
          impressionsAbsTopRate: metricData.impressionsAbsTopRate,
          searchImpressionsShare: metricData.searchImpressionsShare,
          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          clickRevenue: metricData.clickRevenue,
          clickRoas: metricData.clickRoas,
          clickAov: metricData.clickAov,
        },
        campaignGroups: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          impressionsTopRate: metricData.impressionsTopRate,
          impressionsAbsTopRate: metricData.impressionsAbsTopRate,
          searchImpressionsShare: metricData.searchImpressionsShare,
          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          clickRevenue: metricData.clickRevenue,
          clickRoas: metricData.clickRoas,
          clickAov: metricData.clickAov,
        },
        spendAllocation: {
          spend: metricData.spend,
          clickConversions: metricData.clickConversions,
          clickRevenue: metricData.clickRevenue,
          clickCpa: metricData.clickCpa,
          clickRoas: metricData.clickRoas,
        },
      },
      defaults: {
        ecommerce: {
          goalsAndProjections: {},
          primaryKpiCharts: {
            clickRevenue: metricData.clickRevenue,
            clickRoas: metricData.clickRoas,
          },
          primaryKpiTables: {
            spend: metricData.spend,
            clicks: metricData.clicks,
            clickRevenue: metricData.clickRevenue,
            clickRoas: metricData.clickRoas,
          },
          allKpisVsPreviousYear: {
            spend: metricData.spend,
            impressions: metricData.impressions,
            clicks: metricData.clicks,
            cpc: metricData.cpc,
            ctr: metricData.ctr,
            phoneCalls: metricData.phoneCalls,
            clickConversions: metricData.clickConversions,
            cvr: metricData.cvr,
            clickCpa: metricData.clickCpa,
            clickRevenue: metricData.clickRevenue,
            clickRoas: metricData.clickRoas,
            clickAov: metricData.clickAov,
          },
          campaignGroups: {
            spend: metricData.spend,
            clickRevenue: metricData.clickRevenue,
            clickRoas: metricData.clickRoas,
          },
          spendAllocation: {
            spend: metricData.spend,
            clickRevenue: metricData.clickRevenue,
            clickRoas: metricData.clickRoas,
          },
        },
        leadgen: {
          goalsAndProjections: {},
          primaryKpiCharts: {
            clickConversions: metricData.clickConversions,
            clickCpa: metricData.clickCpa,
          },
          primaryKpiTables: {
            spend: metricData.spend,
            clicks: metricData.clicks,
            clickConversions: metricData.clickConversions,
            clickCpa: metricData.clickCpa,
          },
          allKpisVsPreviousYear: {
            spend: metricData.spend,
            impressions: metricData.impressions,
            clicks: metricData.clicks,
            cpc: metricData.cpc,
            ctr: metricData.ctr,
            phoneCalls: metricData.phoneCalls,
            clickConversions: metricData.clickConversions,
            cvr: metricData.cvr,
            clickCpa: metricData.clickCpa,
          },
          campaignGroups: {
            spend: metricData.spend,
            clickConversions: metricData.clickConversions,
            clickCpa: metricData.clickCpa,
          },
          spendAllocation: {
            spend: metricData.spend,
            clickConversions: metricData.clickConversions,
            clickCpa: metricData.clickCpa,
          },
        },
      },
    },
    social: {
      sections: {
        goalsAndProjections: sectionData.goalsAndProjections,
        primaryKpiCharts: sectionData.primaryKpiCharts,
        primaryKpiTables: sectionData.primaryKpiTables,
        allKpisVsPreviousYear: sectionData.allKpisVsPreviousYear,
        campaignGroups: sectionData.campaignGroups,
        spendAllocation: sectionData.spendAllocation,
      },
      metrics: {
        goalsAndProjections: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          views: metricData.views,
          cpv: metricData.cpv,
          viewRate: metricData.viewRate,
          viewCtr: metricData.viewCtr,

          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          addToCarts: metricData.addToCarts,
          impressionToCartRate: metricData.impressionToCartRate,
          checkoutsStarted: metricData.checkoutsStarted,
          cartToConversionRate: metricData.cartToConversionRate,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          clickAov: metricData.clickAov,
          totalAov: metricData.totalAov,
        },
        primaryKpiCharts: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          views: metricData.views,
          cpv: metricData.cpv,
          socialViewRate: metricData.socialViewRate,
          viewCtr: metricData.viewCtr,

          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          addToCarts: metricData.addToCarts,
          impressionToCartRate: metricData.impressionToCartRate,
          checkoutsStarted: metricData.checkoutsStarted,
          cartToConversionRate: metricData.cartToConversionRate,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          clickAov: metricData.clickAov,
          totalAov: metricData.totalAov,
        },
        primaryKpiTables: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          views: metricData.views,
          cpv: metricData.cpv,
          socialViewRate: metricData.socialViewRate,
          viewCtr: metricData.viewCtr,

          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          addToCarts: metricData.addToCarts,
          impressionToCartRate: metricData.impressionToCartRate,
          checkoutsStarted: metricData.checkoutsStarted,
          cartToConversionRate: metricData.cartToConversionRate,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          clickAov: metricData.clickAov,
          totalAov: metricData.totalAov,
        },
        allKpisVsPreviousYear: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          views: metricData.views,
          cpv: metricData.cpv,
          viewRate: metricData.viewRate,
          viewCtr: metricData.viewCtr,

          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          addToCarts: metricData.addToCarts,
          impressionToCartRate: metricData.impressionToCartRate,
          checkoutsStarted: metricData.checkoutsStarted,
          cartToConversionRate: metricData.cartToConversionRate,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          clickAov: metricData.clickAov,
          totalAov: metricData.totalAov,
        },
        campaignGroups: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          views: metricData.views,
          cpv: metricData.cpv,
          socialViewRate: metricData.socialViewRate,
          viewCtr: metricData.viewCtr,

          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          addToCarts: metricData.addToCarts,
          impressionToCartRate: metricData.impressionToCartRate,
          checkoutsStarted: metricData.checkoutsStarted,
          cartToConversionRate: metricData.cartToConversionRate,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          clickAov: metricData.clickAov,
          totalAov: metricData.totalAov,
        },
        spendAllocation: {
          spend: metricData.spend,
          clickConversions: metricData.clickConversions,
          totalConversions: metricData.totalConversions,
          clickRevenue: metricData.clickRevenue,
          totalRevenue: metricData.totalRevenue,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
        },
      },
      defaults: {
        ecommerce: {
          goalsAndProjections: {},
          primaryKpiCharts: {
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
          },
          primaryKpiTables: {
            spend: metricData.spend,
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
          },
          allKpisVsPreviousYear: {
            spend: metricData.spend,
            impressions: metricData.impressions,
            clicks: metricData.clicks,
            cpc: metricData.cpc,
            ctr: metricData.ctr,
            phoneCalls: metricData.phoneCalls,
            addToCarts: metricData.addToCarts,
            impressionToCartRate: metricData.impressionToCartRate,
            checkoutsStarted: metricData.checkoutsStarted,
            cartToConversionRate: metricData.cartToConversionRate,
            totalConversions: metricData.totalConversions,
            cvr: metricData.cvr,
            totalCpa: metricData.totalCpa,
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
            totalAov: metricData.totalAov,
          },
          campaignGroups: {
            spend: metricData.spend,
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
          },
          spendAllocation: {
            spend: metricData.spend,
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
          },
        },
        leadgen: {
          goalsAndProjections: {},
          primaryKpiCharts: {
            totalConversions: metricData.totalConversions,
            totalCpa: metricData.totalCpa,
          },
          primaryKpiTables: {
            spend: metricData.spend,
            totalConversions: metricData.totalConversions,
            totalCpa: metricData.totalCpa,
          },
          allKpisVsPreviousYear: {
            spend: metricData.spend,
            impressions: metricData.impressions,
            clicks: metricData.clicks,
            cpc: metricData.cpc,
            ctr: metricData.ctr,
            phoneCalls: metricData.phoneCalls,
            addToCarts: metricData.addToCarts,
            impressionToCartRate: metricData.impressionToCartRate,
            checkoutsStarted: metricData.checkoutsStarted,
            cartToConversionRate: metricData.cartToConversionRate,
            totalConversions: metricData.totalConversions,
            cvr: metricData.cvr,
            totalCpa: metricData.totalCpa,
          },
          campaignGroups: {
            spend: metricData.spend,
            totalConversions: metricData.totalConversions,
            totalCpa: metricData.totalCpa,
          },
          spendAllocation: {
            spend: metricData.spend,
            totalConversions: metricData.totalConversions,
            totalCpa: metricData.totalCpa,
          },
        },
      },
    },
    display: {
      sections: {
        goalsAndProjections: sectionData.goalsAndProjections,
        primaryKpiCharts: sectionData.primaryKpiCharts,
        primaryKpiTables: sectionData.primaryKpiTables,
        allKpisVsPreviousYear: sectionData.allKpisVsPreviousYear,
        campaignGroups: sectionData.campaignGroups,
        spendAllocation: sectionData.spendAllocation,
      },
      metrics: {
        goalsAndProjections: {
          cpsv: metricData.cpsv,
          spend: metricData.spend,
          impressions: metricData.impressions,
          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          clickAov: metricData.clickAov,
          totalAov: metricData.totalAov,
        },
        primaryKpiCharts: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          clickAov: metricData.clickAov,
          totalAov: metricData.totalAov,
        },
        primaryKpiTables: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          clickAov: metricData.clickAov,
          totalAov: metricData.totalAov,
        },
        allKpisVsPreviousYear: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          clickAov: metricData.clickAov,
          totalAov: metricData.totalAov,
        },
        campaignGroups: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          clickAov: metricData.clickAov,
          totalAov: metricData.totalAov,
        },
        spendAllocation: {
          spend: metricData.spend,
          clickConversions: metricData.clickConversions,
          totalConversions: metricData.totalConversions,
          clickRevenue: metricData.clickRevenue,
          totalRevenue: metricData.totalRevenue,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
        },
      },
      defaults: {
        ecommerce: {
          goalsAndProjections: {},
          primaryKpiCharts: {
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
          },
          primaryKpiTables: {
            spend: metricData.spend,
            impressions: metricData.impressions,
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
          },
          allKpisVsPreviousYear: {
            spend: metricData.spend,
            impressions: metricData.impressions,
            clicks: metricData.clicks,
            cpc: metricData.cpc,
            ctr: metricData.ctr,
            phoneCalls: metricData.phoneCalls,
            totalConversions: metricData.totalConversions,
            cvr: metricData.cvr,
            totalCpa: metricData.totalCpa,
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
            totalAov: metricData.totalAov,
          },
          campaignGroups: {
            spend: metricData.spend,
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
          },
          spendAllocation: {
            spend: metricData.spend,
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
          },
        },
        leadgen: {
          goalsAndProjections: {},
          primaryKpiCharts: {
            totalConversions: metricData.totalConversions,
            totalCpa: metricData.totalCpa,
          },
          primaryKpiTables: {
            spend: metricData.spend,
            impressions: metricData.impressions,
            totalConversions: metricData.totalConversions,
            totalCpa: metricData.totalCpa,
          },
          allKpisVsPreviousYear: {
            spend: metricData.spend,
            impressions: metricData.impressions,
            clicks: metricData.clicks,
            cpc: metricData.cpc,
            ctr: metricData.ctr,
            phoneCalls: metricData.phoneCalls,
            totalConversions: metricData.totalConversions,
            cvr: metricData.cvr,
            totalCpa: metricData.totalCpa,
          },
          campaignGroups: {
            spend: metricData.spend,
            totalConversions: metricData.totalConversions,
            totalCpa: metricData.totalCpa,
          },
          spendAllocation: {
            spend: metricData.spend,
            totalConversions: metricData.totalConversions,
            totalCpa: metricData.totalCpa,
          },
        },
      },
    },
    video: {
      sections: {
        goalsAndProjections: sectionData.goalsAndProjections,
        primaryKpiCharts: sectionData.primaryKpiCharts,
        primaryKpiTables: sectionData.primaryKpiTables,
        allKpisVsPreviousYear: sectionData.allKpisVsPreviousYear,
        campaignGroups: sectionData.campaignGroups,
        spendAllocation: sectionData.spendAllocation,
      },
      metrics: {
        goalsAndProjections: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          viewableImpressions: metricData.viewableImpressions,
          views: metricData.views,
          cpv: metricData.cpv,
          viewRate: metricData.viewRate,
          viewCtr: metricData.viewCtr,
          viewableCtr: metricData.viewableCtr,

          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          videoCvr: metricData.videoCvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          clickAov: metricData.clickAov,
          totalAov: metricData.totalAov,
        },
        primaryKpiCharts: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          viewableImpressions: metricData.viewableImpressions,
          views: metricData.views,
          cpv: metricData.cpv,
          viewRate: metricData.viewRate,
          viewCtr: metricData.viewCtr,
          viewableCtr: metricData.viewableCtr,

          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          videoCvr: metricData.videoCvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          clickAov: metricData.clickAov,
          totalAov: metricData.totalAov,
        },
        primaryKpiTables: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          viewableImpressions: metricData.viewableImpressions,
          views: metricData.views,
          cpv: metricData.cpv,
          viewRate: metricData.viewRate,
          viewCtr: metricData.viewCtr,
          viewableCtr: metricData.viewableCtr,

          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          videoCvr: metricData.videoCvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          clickAov: metricData.clickAov,
          totalAov: metricData.totalAov,
        },
        allKpisVsPreviousYear: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          viewableImpressions: metricData.viewableImpressions,
          views: metricData.views,
          cpv: metricData.cpv,
          viewRate: metricData.viewRate,
          viewCtr: metricData.viewCtr,
          viewableCtr: metricData.viewableCtr,

          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          videoCvr: metricData.videoCvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          clickAov: metricData.clickAov,
          totalAov: metricData.totalAov,
        },
        campaignGroups: {
          spend: metricData.spend,
          impressions: metricData.impressions,
          viewableImpressions: metricData.viewableImpressions,
          views: metricData.views,
          cpv: metricData.cpv,
          viewRate: metricData.viewRate,
          viewCtr: metricData.viewCtr,
          viewableCtr: metricData.viewableCtr,

          clicks: metricData.clicks,
          cpc: metricData.cpc,
          ctr: metricData.ctr,
          phoneCalls: metricData.phoneCalls,
          inStoreVisits: metricData.inStoreVisits,
          clickConversions: metricData.clickConversions,
          viewConversions: metricData.viewConversions,
          totalConversions: metricData.totalConversions,
          cvr: metricData.cvr,
          videoCvr: metricData.videoCvr,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRevenue: metricData.clickRevenue,
          viewRevenue: metricData.viewRevenue,
          totalRevenue: metricData.totalRevenue,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
          clickAov: metricData.clickAov,
          totalAov: metricData.totalAov,
        },
        spendAllocation: {
          spend: metricData.spend,
          clickConversions: metricData.clickConversions,
          totalConversions: metricData.totalConversions,
          clickRevenue: metricData.clickRevenue,
          totalRevenue: metricData.totalRevenue,
          clickCpa: metricData.clickCpa,
          totalCpa: metricData.totalCpa,
          clickRoas: metricData.clickRoas,
          totalRoas: metricData.totalRoas,
        },
      },
      defaults: {
        ecommerce: {
          goalsAndProjections: {},
          primaryKpiCharts: {
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
          },
          primaryKpiTables: {
            spend: metricData.spend,
            views: metricData.views,
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
          },
          allKpisVsPreviousYear: {
            spend: metricData.spend,
            impressions: metricData.impressions,
            views: metricData.views,
            cpv: metricData.cpv,
            clicks: metricData.clicks,
            cpc: metricData.cpc,
            ctr: metricData.ctr,
            phoneCalls: metricData.phoneCalls,
            totalConversions: metricData.totalConversions,
            videoCvr: metricData.videoCvr,
            totalCpa: metricData.totalCpa,
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
            totalAov: metricData.totalAov,
          },
          campaignGroups: {
            spend: metricData.spend,
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
          },
          spendAllocation: {
            spend: metricData.spend,
            totalRevenue: metricData.totalRevenue,
            totalRoas: metricData.totalRoas,
          },
        },
        leadgen: {
          goalsAndProjections: {},
          primaryKpiCharts: {
            totalConversions: metricData.totalConversions,
            totalCpa: metricData.totalCpa,
          },
          primaryKpiTables: {
            spend: metricData.spend,
            views: metricData.views,
            totalConversions: metricData.totalConversions,
            totalCpa: metricData.totalCpa,
          },
          allKpisVsPreviousYear: {
            spend: metricData.spend,
            impressions: metricData.impressions,
            views: metricData.views,
            cpv: metricData.cpv,
            clicks: metricData.clicks,
            cpc: metricData.cpc,
            ctr: metricData.ctr,
            phoneCalls: metricData.phoneCalls,
            totalConversions: metricData.totalConversions,
            videoCvr: metricData.videoCvr,
            totalCpa: metricData.totalCpa,
          },
          campaignGroups: {
            spend: metricData.spend,
            totalConversions: metricData.totalConversions,
            totalCpa: metricData.totalCpa,
          },
          spendAllocation: {
            spend: metricData.spend,
            totalConversions: metricData.totalConversions,
            totalCpa: metricData.totalCpa,
          },
        },
      },
    },
  };

  allMetrics["metricsByDashboard"] = metricsByDashboard;
  allMetrics["metricData"] = metricData;
  allMetrics["sectionData"] = sectionData;

  return allMetrics;
};
